module.exports = __webpack_public_path__ + "57c6d2b86e5206f4847a28b447e04789.svg";